import * as baseDefs from './base';
import * as defaultsDefs from './defaults';
import * as mobileDefs from './mobile';
import * as motionDefs from './motion';
import * as transitionDefs from './transitions';
function generateDefs(defs, baseToExtend) {
    const defsArray = [...Object.values(defs)];
    return defsArray.reduce((acc, def) => {
        acc[def.name] = def;
        return acc;
    }, { ...baseToExtend });
}
const base = generateDefs(baseDefs, {});
const transitions = generateDefs(transitionDefs, base);
const defaults = generateDefs(defaultsDefs, transitions);
const mobile = generateDefs(mobileDefs, defaults);
const motion = generateDefs(motionDefs, base);
export const definitions = {
    defaults: defaults,
    mobile: mobile,
    motion: motion,
};
//# sourceMappingURL=definitions.js.map